
import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import filtericon from '../../../assets/icons/mage_filter-fill.svg'
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getBlob, getBloblive, getData, getDataById, getSingleDataById, patchData, postBlob, Postdata, PostFileData, updateData } from '../../../API/GlobalApi.js';
import { ReceivePayment } from '../../../Component/Modals/ReceivePaymentModal.js';
import { RefundPayment } from '../../../Component/Modals/RefundPaymentModal.js';
import exporticon from '../../../assets/icons/export-data.svg';
import { IndividualReceivePayment } from '../../../Component/Modals/IndividualStudentReceivePaymentModal.js';
import { handlePaginate } from '../../../Utils/handlePagination.js';
import SearchingBar from '../../../Utils/Searching.js';
import SpinnerLoader from '../../../Utils/Spinner.js';
import Notifier from '../../../Utils/notify.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import { formatDateDDMMYYYYHHMMSS, formatDateYYYYMMDD } from '../../../Utils/data&dateTime.js';
import ProfileStatus from '../../../Component/ProfileStatus.js';
import profileicon from '../../../assets/icons/money-tgrant-success-line-svgrepo-com.svg'
import profileicon2 from '../../../assets/icons/draft-svgrepo-com.svg'
import profileicon3 from '../../../assets/icons/cheque-payment-svgrepo-com.svg'
import profileicon4 from '../../../assets/icons/amount-svgrepo-com.svg'
import FilterTransactionModal from '../../../Component/Modals/FilterTransactionModal.js';
import { TransactionsShortDetails } from './TransactionsShortDetails.js';
import { TransferTransactions } from '../../../Component/Modals/TransferTransactions.js';
import { RemittanceShortDetails } from './RemittanceShortDetails.js';
import TransactionsStats from '../../../Component/Modals/TransactionsStats.js';
import { TransferReconcile } from '../../../Component/Modals/ReconcileTransfer.js';
import OtpModal from '../../../Component/Modals/DiscountOtpInput.js';
import { CashReconcile } from '../../../Component/Modals/CashReconcile.js';
import RemittanceTransactions from './RemittanceTransactions.js';
import { ReceiveTransactions } from './ReceiveTransactions.js';
import { useHasPermission } from '../../../Utils/checkPermissions.js';
import { useTableFade } from '../../../Utils/tableFadeHooks.js';
import TableLoaderOverlay from '../../../Utils/tableFadingLoader.js';

const TransactionsLayouts = () => {


    const hasPermission = useHasPermission();

    const [receivingEmployeeData, setReceivingEmployeeData] = useState({
        transactions_received_from: [],
        transactions_received_by: [],
        remittances_deposited_by: [],
        remittances_deposited_in: [],
    });
    const [receiveFilters, setReceiveFilters] = useState({
        receivedBy: null,
        receivedFrom: null,
        depositedBy: null,
        depositedIn: null,
    });

    const getToday = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }
    const { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();
    const [isReceivedPaymentModalOpen, setIsReceivedPaymentModal] = useState(false);
    const [selectedFeeDetails, setselectedFeeDetails] = useState([]);
    const today = getToday(); // e.g., "2025-12-23"


    // ✅ Initialize filterQueryString with current date
    const [filterQueryString, setFilterQueryString] = useState({
        start_date: today,
        end_date: today
    });
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const openModal = () => {
        setIsReceivedPaymentModal(true);
    };
    const navigate = useNavigate()
    const closeModal = () => {
        setIsReceivedPaymentModal(false);

    };

    const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
    const openRefundModal = () => {
        setIsRefundModalOpen(true);
    };
    const closeRefundModal = () => {
        setIsRefundModalOpen(false);
    };
    const location = useLocation();
    const isRemittance = location.pathname.includes("remittances");
    const isTransactions = location.pathname.includes("transactions");


    const activeTab =
        location.pathname.includes("remittances") ? "remittance" : "receiving";

    const [individualReceivePaymentModal, setIndividualReceivePaymentModal] = useState(false)
    const closeIndividualReceivePaymentModal = () => {
        setIndividualReceivePaymentModal(false);

    };

    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [filterLoading, setFilterLoading] = useState(false);
    const [txndata, setTxnsdata] = useState([]);
    const [showTransferTransactionsModal, setShowTransferTransactionsModals] = useState(false)
    const [showTransferReconcileModal, setShowTransferReconcileModals] = useState(false)
    const [filterTxn, setFilterTxn] = useState([])
    const [selectedTxnDetails, setselectedTxnDetails] = useState([]);
    const [selectedTxnStats, setselectedTxnStats] = useState([]);
    const [selectedTxnForReconcile, setselectedTxnForReconcile] = useState([]);
    const [openCashInHandsReconcile, setCashInHandsReconcile] = useState(false)
    const [isSearchPending, setIsSearchPending] = useState(false);
    const showSpinner = isSearchPending || isSearchLoading;

    const closeCashInHandsReconcileModal = () => {
        setCashInHandsReconcile(false)
    }
    const handleCashInHandsReconcile = () => {
        setCashInHandsReconcile(true)
    }


    const getTxnDetailsById = async (transaction_id) => {
        try {
            const response = await getSingleDataById(`finance/transactions`, transaction_id);
            if (response) {
                setselectedTxnDetails(response);
            } else {
                setselectedTxnDetails(null);
            }
        } catch (error) {
            Notifier.error("Failed to fetch transaction details");
            setselectedTxnDetails(null);
        }
    };



    const openTransferTransactionsModal = () => {
        setShowTransferTransactionsModals(true)
    }

    const closeTransferTransactionsModal = () => {
        setselectedTxnStats(null)
        setShowTransferTransactionsModals(false)
    }

    const openTransferReconcileModal = () => {
        setShowTransferReconcileModals(true)
    }

    const closeTransferReconcileModal = () => {
        setselectedTxnForReconcile(null)
        setShowTransferReconcileModals(false)
    }


    const handleTransfer = (selected) => {
        let details = null;

        if (selected.type === "No of cheque") {
            details = txnstats?.payment_method_summary?.find(m => m.payment_method === "Cheque")?.payment_details;
        } else if (selected.type === "No of demand draft") {
            details = txnstats?.payment_method_summary?.find(m => m.payment_method === "Demand Draft")?.payment_details;
        }

        setselectedTxnStats({
            ...selected,
            payment_details: details
        });

        setShowTransferTransactionsModals(true);
    };

    const handleRowClick = async (txnId, row) => {
        try {
            // console.log("roewww",row.original)
            // await getTxnDetailsById(txnId);
            setselectedTxnDetails(row.original)
        } catch (error) {

        }
    };

    const [fromDate, setFromDate] = useState(getToday());
    const [toDate, setToDate] = useState(getToday());
    const [txnstats, setTxnStats] = useState();
    const [statusFilter, setStatusFilter] = useState([]);
    const [activeTabFilterModal, setActiveTabFiltermodal] = useState("date");
    const [instrumentType, setInstrumentType] = useState([]);
    const [remitterName, setRemitterName] = useState("");

    const [isSearchModeFeeRemitance, setIsSearchModeFeeRemitance] = useState(false);

    const normalizeQueryParams = (value) => {
        if (!value) return new URLSearchParams();

        if (typeof value === "string") {
            return new URLSearchParams(value);
        }

        if (typeof value === "object" && value !== null) {
            return new URLSearchParams(value);
        }

        return new URLSearchParams();
    };

    const getTransactions = async (page = 0, filters = "",) => {
        // const query = filters || filterQueryString || `start_date=${fromDate}&end_date=${toDate}`;
        // const url = `finance/remittances/?page=${page + 1}&${query}`;

        // const query = normalizeQueryString(
        //     filters || filterQueryString || {
        //         start_date: fromDate,
        //         end_date: toDate
        //     }
        // );
        // params.set("page", page + 1);
        // const url = query
        //     ? `finance/remittances/?page=${page + 1}&${query}`
        //     : `finance/remittances/?page=${page + 1}`;

        const params = normalizeQueryParams(
            filters || filterQueryString || {
                start_date: fromDate,
                end_date: toDate
            }
        );

        // ✅ SAFE — replaces existing page
        params.set("page", page + 1);

        const url = `finance/remittances/?${params.toString()}`;

        if (isInitialLoad) setIsLoading(true);
        else setSearchLoading(true);
        try {
            const response = await getData(url);

            const pageSize = 10;
            const total = response?.count || 0;
            const lastValidPage = Math.max(0, Math.ceil(total / pageSize) - 1);

            // 🔴 FIX: invalid page after delete/reconcile
            if (page > lastValidPage) {
                setCurrentPage(lastValidPage);
                return;
            }




            if (response?.results?.length > 0) {
                setTotalCount(response.count || 0);
                setTxnsdata(response.results);
                setFilterTxn(response.results)

                if (response?.results?.length > 0) {
                    const firstTxnId = response?.results[0];
                    setselectedTxnDetails(firstTxnId)
                    // await getTxnDetailsById(firstTxnId);
                }
            } else {
                setFilterTxn([])
                setTxnsdata([]);
                setselectedFeeDetails(null);
                setTotalCount(0);
            }
        } catch (error) {
            Notifier.error("Error fetching transactions");
        } finally {
            if (isInitialLoad) {
                setIsLoading(false);
                setIsInitialLoad(false);
            } else {
                setSearchLoading(false);
            }
            setFilterLoading(false);
            setOpenFilterModal(false);
        }
    };





    const buildFilterQueryRemittance = () => {
        const start = fromDate ? `start_date=${fromDate}` : "";
        const end = toDate ? `end_date=${toDate}` : "";
        return [start, end].filter(Boolean).join("&");
    };
    useEffect(() => {
        if (isSearchModeFeeRemitance) return;
        // const filters = buildFilterQueryRemittance();
        // setFilterQueryString(filters); // store filters only
        getTransactions(currentPage, filterQueryString).finally(() => stopTableLoading()); // hide fade after completion;
    }, [currentPage, filterQueryString]);




    const [modeOfPayment, setModeOfPayment] = useState([]);

    const getModeOfPayment = async () => {
        const url = 'students/get-payment-method-choices/'
        const response = await getData(url)
        setModeOfPayment(response?.payment_method_choices)
    }

    const getTransactionStats = async () => {
        const res = await getData('finance/payments/instruments-in-hand/')
        setTxnStats(res)
    }
    const [helpdeskperson, setHelpDeskPerson] = useState([]);




    const getReceivingEmployee = async () => {
        try {
            const res = await getData("finance/transactions/parties/");
            setReceivingEmployeeData({
                transactions_received_from: res?.transactions_received_from || [],
                transactions_received_by: res?.transactions_received_by || [],
                remittances_deposited_by: res?.remittances_deposited_by || [],
                remittances_deposited_in: res?.remittances_deposited_in || [],
            });
        } catch (error) {
            Notifier.error("Error fetching receiving employee data:", error);
        }
    };





    useEffect(() => {
        const fetchAllData = async () => {
            try {
                const [modeRes, helpdeskRes] = await Promise.all([
                    getData("students/get-payment-method-choices/"),
                    getData("finance/course-fee-plans/authorized-employees/?type=balance-transfer"),
                ]);

                setModeOfPayment(modeRes?.payment_method_choices || []);
                // setHelpDeskPerson(helpdeskRes || []);

                setHelpDeskPerson(
                    helpdeskRes?.authorized_employees?.map((emp) => ({
                        value: emp.id,
                        label: emp.name,
                    })) || []
                );
            } catch (err) {
                console.error("Error fetching initial data:", err);
            }
        };
        getTransactionStats()
        fetchAllData();
        getReceivingEmployee()
    }, []);



    const sourceData = useMemo(() => {
        return filterQueryString ? filterTxn : txndata;
    }, [txndata, filterTxn, filterQueryString]);


    const formattedData = useMemo(() => {
        return sourceData?.map((txn) => ({
            id: txn.id,
            remitance_number: txn.remitance_number,
            created_at: txn.created_at,
            transfered_from: txn.transfered_from,
            transfered_to: txn.transfered_to,
            instrument: txn.instrument,
            transaction_details: txn.transaction_details,
            amount: txn.amount,
            cash_unique_id: txn.cash_unique_id,
            type: txn.type,
            verified: txn.verified,
            status: txn.status,
            remarks: txn.remarks,
            deposit_slip_url: txn.deposit_slip_url,
            handleRowClick,
        }));
    }, [sourceData]);




    const handleSetSearchResults = (data) => {
        let transactions =
            Array.isArray(data)
                ? data
                : Array.isArray(data?.results)
                    ? data.results
                    : [];

        setFilterTxn(transactions);
        // ⭐ IMPORTANT: clear selection if no data
        if (transactions.length === 0) {
            setselectedTxnDetails([]);
        }

    };

    const lastValidRemitFilterRef = useRef('');






    useEffect(() => {
        let query = "";

        if (typeof filterQueryString === "string") {
            query = filterQueryString;
        } else if (
            typeof filterQueryString === "object" &&
            filterQueryString !== null
        ) {
            query = new URLSearchParams(filterQueryString).toString();
        }

        if (query.trim() !== "") {
            lastValidRemitFilterRef.current = query;
        }
    }, [filterQueryString]);

    // Reset pagination to first page whenever filters or search query change
    // useEffect(() => {
    //     setCurrentPage(0);
    // }, [filterQueryString]);



    const [pageLoading, setPageLoading] = useState(false);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected)
        triggerTableLoading();

        // let rawQuery = filterQueryString?.trim() || '';
        // // if search is cleared, don’t use lastValidFilterQueryRef
        // if (!rawQuery && lastValidRemitFilterRef.current.includes('search=')) {
        //     rawQuery = lastValidRemitFilterRef.current.replace(/(&|\?)search=[^&]*/g, '');
        // } else if (!rawQuery) {
        //     rawQuery = lastValidRemitFilterRef.current;
        // }

        // const cleanQuery = rawQuery
        //     .replace(/(&|\?)page=\d+/g, '')
        //     .replace(/^&/, '');
        // handlePaginate({
        //     selectedPage: selected,
        //     url: 'finance/remittances/',
        //     filterQueryString: cleanQuery,
        //     setResults: handleSetSearchResults,
        //     setTotalCount,
        //     setFilterQueryString,
        //     setLoading: setPageLoading,
        //     triggerTableLoading,
        //     stopTableLoading
        // });
    };







    const [openFilterModal, setOpenFilterModal] = useState(false)
    const closeFilterModal = () => {
        setOpenFilterModal(false)
    }
    const [isSearchingRemittancesReceive, setIsSearchingRemittancesReceive] = useState(false);

    const handleRemittancesSearch = async () => {
        if (!fromDate || !toDate) {
            Notifier.error("Please select both From and To dates");
            return;
        }
        setSearchLoading(true);
        // try {
        //     setIsSearchingRemittancesReceive(true)

        const from = new Date(fromDate);
        const to = new Date(toDate);
        const formattedFrom = formatDateYYYYMMDD(from);
        const formattedTo = formatDateYYYYMMDD(to);

        // ✅ Build query params
        let query = `start_date=${formattedFrom}&end_date=${formattedTo}`;

        // status filter
        if (statusFilter && statusFilter.length > 0) {
            const statusParams = statusFilter.map(s => s.value).join(",");
            query += `&status=${statusParams}`;
        }

        // instrument filter
        if (instrumentType && instrumentType.length > 0) {
            const instrumentParams = instrumentType.map(s => s.value).join(",");
            query += `&mode_of_payment=${instrumentParams}`;
        }


        if (remitterName && remitterName.trim() !== "") {
            query += `&search=${encodeURIComponent(remitterName.trim())}`;
        }

        if (receiveFilters?.depositedBy?.value) {
            query += `&deposited_by=${receiveFilters.depositedBy.value}`;
        }

        if (receiveFilters?.depositedIn?.value) {
            query += `&deposited_in=${receiveFilters.depositedIn.value}`;
        }


        // ✅ Received From filter
        if (receiveFilters?.receivedFrom?.value) {
            query += `&transfered_from=${receiveFilters.receivedFrom.value}`;
        }

        // ✅ Received By filter
        if (receiveFilters?.receivedBy?.value) {
            query += `&transfered_to=${receiveFilters.receivedBy.value}`;
        }
        setCurrentPage(0);

        // 🔹 Save filters
        setFilterQueryString(query);

        // 🔹 Trigger API call for page 1
        // await getTransactions(0, query);
        // closeFilterModal();
        setActiveTabFiltermodal("date");
        // } catch (err) {
        //     Notifier.error("Search failed");
        // } finally {
        //     setIsSearchingRemittancesReceive(false); // ✅ ALWAYS TURN OFF
        // }
    }




    const [otpModalOpen, setOtpModalOpen] = useState(false);
    const [studentResponse, setStudentResponse] = useState('')


    const handleConfirmOtp = async (otpCode) => {

        const url = 'finance/cash-transfer/verify-otp/';
        const payload = {
            cash_unique_id: studentResponse.cash_unique_id,
            otp: otpCode
        };
        try {
            const response = await Postdata(url, payload);
            if (!response?.error) {
                Notifier.success(response.message || "OTP verified successfully!");
                // setHelpDeskPerson([])
                setStudentResponse('')
                setOtpModalOpen(false);
                getTransactions(currentPage, filterQueryString);
            } else {
                // ✅ use error if message not present
                const errMsg = response.error || response.message || "Failed to verify OTP.";
                Notifier.error(errMsg);
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);

            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.error ||   // ✅ backend may return error key
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };

    const handleCancelOtp = () => {
        setOtpModalOpen(false);
    };


    const [cashIdState, setCashIdState] = useState(null);

    const handleResendOtp = async (row) => {
        setselectedTxnDetails(row)
        setOtpModalOpen(true)
        const url = 'finance/cash-transfer/resend-otp/';

        setCashIdState(row.cash_unique_id);
        const payload = {
            cash_unique_id: row.cash_unique_id,
            employee_id: row.transfered_from.id,
            remitance_number: row?.remitance_number
        };
        try {
            const response = await Postdata(url, payload);

            if (!response?.error) {
                const cashId = response.cash_unique_id || row.cash_unique_id;
                setCashIdState(cashId);
                setStudentResponse({
                    otp: response.otp,
                    cash_unique_id: cashId,
                    employee_name: response?.employee_name,
                    employee_mobile: response?.employee_mobile,
                });
                Notifier.success(`OTP has been successfully sent to ${selectedTxnDetails?.transfered_from?.name}.`);

            } else {

                Notifier.error(response.error || "Failed to resend OTP.");
            }
        } catch (error) {

            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };


    const handlesResendOtpToAssignedPerson = async (employeeIds = []) => {

        const cashId = studentResponse?.cash_unique_id || cashIdState;

        if (!cashId) {
            Notifier.error("Cannot resend OTP: cash ID is missing.");
            return;
        }
        const url = 'finance/cash-transfer/resend-otp/';
        const payload = {
            cash_unique_id: cashId,
            employee_id: Array.isArray(employeeIds) ? employeeIds[0] : employeeIds
        };
        try {
            const response = await Postdata(url, payload);
            if (!response?.error) {
                setStudentResponse({ otp: response.otp, cash_unique_id: response.cash_unique_id, employee_name: response?.employee_name, employee_mobile: response?.employee_mobile })
                Notifier.success(`OTP has been successfully resent to ${response?.employee_name}.`);

            } else {
                Notifier.error(response.error || "Failed to resend OTP.");
            }
        } catch (error) {

            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };



    const handleExportExcelRemittance = async () => {
        try {
            const params = new URLSearchParams();

            // Add all current filter parameters directly
            if (filterQueryString) {
                const extraParams = new URLSearchParams(filterQueryString);
                extraParams.forEach((value, key) => {
                    params.set(key, value); // use set instead of append to avoid duplicates
                });
            }


            // ✅ always add base date filters
            if (fromDate) params.set("start_date", fromDate);
            if (toDate) params.set("end_date", toDate);

            // // ✅ merge filter query if it exists
            // if (filterQueryString) {
            //     const extraParams = new URLSearchParams(filterQueryString);
            //     extraParams.forEach((value, key) => {
            //         // avoid duplicate start/end date
            //         if (key !== "start_date" && key !== "end_date") {
            //             params.append(key, value);
            //         }
            //     });
            // }

            const urlWithParams = `finance/remittances/export/excel/?${params.toString()}`;

            const blob = await getBloblive(urlWithParams);

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Remittances_export.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            Notifier.error(error);
        }
    };




    ///////////////////------------------------------------------------------------------------------/Fee recevied 
    const [isSearchLoadingFeeReceive, setSearchLoadingFeeReceive] = useState(false);
    const [isLoadingFeeReceive, setIsLoadingFeeReceive] = useState(true);
    const [isInitialLoadFeeReceive, setIsInitialLoadFeeReceive] = useState(true);
    const [filterLoadingFeeReceive, setFilterLoadingFeeReceive] = useState(false);
    const [feeReceiveData, setFeeReceiveData] = useState([]);
    // const [showTransferTransactionsModal, setShowTransferTransactionsModals] = useState(false)
    const [filterFeeReceive, setFilterFeeReceive] = useState([])
    const [selectedFeeReceive, setselectedFeeReceive] = useState([]);
    const [fromDateFeeReceive, setFromDateFeeReceive] = useState(getToday());
    const [toDateFeeReceive, setToDateFeeReceive] = useState(getToday());
    const [activeTabFilterModalFeeReceive, setActiveTabFiltermodalFeeReceive] = useState("date");
    const [instrumentTypeFeeReceive, setInstrumentTypeFeeReceive] = useState([]);
    // const [filterQueryStringFeeReceive, setFilterQueryStringFeeReceive] = useState('');



    // ✅ Initialize filterQueryString with current date
    const [filterQueryStringFeeReceive, setFilterQueryStringFeeReceive] = useState({
        start_date: today,
        end_date: today
    });
    const [statusFilterFeeReceive, setStatusFilterFeeReceive] = useState([]);
    const [currentPageFeeReceive, setCurrentPageFeeReceive] = useState(0);
    const [totalCountFeeReceive, setTotalCountFeeReceive] = useState(0);
    const pageSizeFeeReceive = 10;
    const pageCountsFeeReceive = Math.ceil(totalCountFeeReceive / pageSizeFeeReceive);

    const [isSearchPendingFeeReceive, setIsSearchPendingFeeReceive] = useState(false);
    const showSpinnerFeeReceive = isSearchPendingFeeReceive || isSearchLoadingFeeReceive;

    const searchInputRef = useRef(null); // make sure this exists

    useEffect(() => {
        // whenever the active tab changes, focus the search input
        searchInputRef.current?.focus();
    }, [activeTab]); // dependency on tab



    const [isSearchingFeeReceive, setIsSearchingFeeReceive] = useState(false);

    const handleFeeReceiveSearch = async () => {
        if (!fromDateFeeReceive || !toDateFeeReceive) {
            Notifier.error("Please select both From and To dates");
            return;
        }
        setSearchLoadingFeeReceive(true)
        // setIsSearchingFeeReceive(true);
        // try {
        const from = new Date(fromDateFeeReceive);
        const to = new Date(toDateFeeReceive);
        const formattedFrom = formatDateYYYYMMDD(from);
        const formattedTo = formatDateYYYYMMDD(to);

        // ✅ Build query params
        let query = `start_date=${formattedFrom}&end_date=${formattedTo}`;

        // status filter
        if (statusFilterFeeReceive && statusFilterFeeReceive.length > 0) {
            const statusParams = statusFilterFeeReceive.map(s => s.value).join(",");
            query += `&status=${statusParams}`;
        }

        // instrument filter
        if (instrumentTypeFeeReceive && instrumentTypeFeeReceive.length > 0) {
            const instrumentParams = instrumentTypeFeeReceive.map(s => s.value).join(",");
            query += `&mode_of_payment=${instrumentParams}`;
        }

        // ✅ Received From filter
        if (receiveFilters?.receivedFrom?.value) {
            query += `&transfered_from=${receiveFilters.receivedFrom.value}`;
        }

        // ✅ Received By filter
        if (receiveFilters?.receivedBy?.value) {
            query += `&transfered_to=${receiveFilters.receivedBy.value}`;
        }
        // // remitter name filter
        // // remitter name filter
        // if (remitterName && remitterName.trim() !== "") {
        //     query += `&search=${encodeURIComponent(remitterName.trim())}`;
        // }


        // 🔹 Reset page to 0 before API call
        setCurrentPageFeeReceive(0);

        // 🔹 Save filters
        setFilterQueryStringFeeReceive(query);

        // 🔹 Trigger API call for page 1
        // await getFeeReceivedData(0, query);

        // closeFilterModal();
        setActiveTabFiltermodalFeeReceive("date");

        // } catch (err) {
        //     Notifier.error("Search failed");
        // } finally {
        //     setIsSearchingFeeReceive(false); // ✅ ALWAYS TURN OFF
        // }

    };





    const getFeeReceiveDetailsById = async ({ singleDataid, id, transfer_id }) => {
        try {
            let url = "";
            if (singleDataid) {
                url = `finance/transactions/?id=${singleDataid}`;
            } else if (transfer_id) {
                url = `finance/transactions/?transfer_id=${transfer_id}`;
            } else if (id) {
                url = `finance/transactions/?id=${id}`;
            } else {
                console.warn("No valid identifier found for transaction details");
                return;
            }

            const response = await getData(url);
            setselectedFeeReceive(response || null);
        } catch (error) {
            Notifier.error("Failed to fetch transaction details");
            setselectedFeeReceive(null);
        }
    };

    const normalizeQueryString = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value;
        if (typeof value === "object" && value !== null) {
            return new URLSearchParams(value).toString();
        }
        return "";
    };
    const [isSearchModeFeeReceive, setIsSearchModeFeeReceive] = useState(false);


    const getFeeReceivedData = async (page = 0, filters = "") => {

        // const query = filters || filterQueryStringFeeReceive || `start_date=${fromDateFeeReceive}&end_date=${toDateFeeReceive}`;


        const query = normalizeQueryString(
            filters || filterQueryStringFeeReceive || {
                start_date: fromDateFeeReceive,
                end_date: toDateFeeReceive
            }
        );
        const url = query
            ? `finance/transactions/?page=${page + 1}&${query}`
            : `finance/transactions/?page=${page + 1}`;

        // const url = `finance/transactions/?page=${page + 1}&${query}`;

        if (isInitialLoadFeeReceive) setIsLoadingFeeReceive(true);
        else setSearchLoadingFeeReceive(true);

        try {
            const response = await getData(url);

            if (response?.results?.length > 0) {
                setTotalCountFeeReceive(response.count || 0);
                setFeeReceiveData(response.results);
                setFilterFeeReceive(response.results);
                const firstTxn = response.results[0];
                if (firstTxn) await getFeeReceiveDetailsById(firstTxn);
            } else {
                setFeeReceiveData([]);
                setFilterFeeReceive([]);
                setselectedFeeReceive(null);
                setTotalCountFeeReceive(0);
            }
        } catch (error) {
            Notifier.error("Error fetching transactions");
        } finally {
            if (isInitialLoadFeeReceive) {
                setIsLoadingFeeReceive(false);
                setIsInitialLoadFeeReceive(false);
            } else {
                setSearchLoadingFeeReceive(false);
            }
            setFilterLoadingFeeReceive(false);
            setOpenFilterModal(false)
        }
    };



    const buildFilterQuery = () => {
        const start = fromDateFeeReceive ? `start_date=${fromDateFeeReceive}` : "";
        const end = toDateFeeReceive ? `end_date=${toDateFeeReceive}` : "";
        return [start, end].filter(Boolean).join("&");
    };

    useEffect(() => {
        if (currentPageFeeReceive !== 0) {
            setCurrentPageFeeReceive(0);
        }
    }, [filterQueryStringFeeReceive]);


    useEffect(() => {
        if (isSearchModeFeeReceive) return;
        // const filters = buildFilterQuery();
        // setFilterQueryStringFeeReceive(filters); // store filters only
        getFeeReceivedData(currentPageFeeReceive, filterQueryStringFeeReceive).finally(() => stopTableLoading());;
    }, [currentPageFeeReceive, filterQueryStringFeeReceive]);


    const handleExportExcel = async () => {
        try {
            const params = new URLSearchParams();

            // Add all current filter parameters directly
            if (filterQueryStringFeeReceive) {
                const extraParams = new URLSearchParams(filterQueryStringFeeReceive);
                extraParams.forEach((value, key) => {
                    params.set(key, value); // use set instead of append to avoid duplicates
                });
            }
            // ✅ always add base date filters
            if (fromDateFeeReceive) params.set("start_date", fromDateFeeReceive);
            if (toDateFeeReceive) params.set("end_date", toDateFeeReceive);

            // ✅ merge filter query if it exists
            // if (filterQueryStringFeeReceive) {
            //     const extraParams = new URLSearchParams(filterQueryStringFeeReceive);
            //     extraParams.forEach((value, key) => {
            //         // avoid duplicate start/end date
            //         if (key !== "start_date" && key !== "end_date") {
            //             params.append(key, value);
            //         }
            //     });
            // }
            const urlWithParams = `finance/transactions/export/excel/?${params.toString()}`;
            const blob = await getBloblive(urlWithParams);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Fee_receive_export.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            Notifier.error(error);
        }
    };


    const handleRowClickReceiveFee = async (txnId, row) => {
        try {
            await getFeeReceiveDetailsById(row.original);
        } catch (error) {
            console.error("Error in handleRowClick:", error);
        }
    };

    const sourceDataFeReceive = useMemo(() => {
        return filterQueryStringFeeReceive ? filterFeeReceive : feeReceiveData;
    }, [feeReceiveData, filterFeeReceive, filterQueryStringFeeReceive]);


    const formattedDataFeeReceived = useMemo(() => {
        return sourceDataFeReceive?.map((txn, index) => ({
            singleDataid: txn.id,
            id: txn.transfer_id
                ? `${txn.transfer_id}-${Date.now()}-${Math.floor(Math.random() * 1000)}`
                : `${txn.id}-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
            transaction_id: txn.transaction_id,
            transfer_id: txn.transfer_id,
            student_name: txn?.student_name,
            student_mother_name: txn?.student_mother_name,
            student_father_name: txn?.student_father_name,
            academic_year: txn?.academic_year,
            student_gender: txn?.student_gender,
            permanent_registration_number: txn.permanent_registration_number,
            course_name: txn.lag?.name,
            contact_number: txn.mobile,
            payment_method: txn.payment_method,
            payment_status: txn.payment_status,
            payment_date: txn.created_at,
            amount: txn.amount,
            cheque_details: txn.cheque_details || '',
            dd_details: txn.dd_details || '',
            neft_rtgs_details: txn.neft_rtgs_details || '',
            receipt_number: txn.receipt_number,
            created_at: txn.created_at,
            handleRowClickReceiveFee, // for row click action
        }));
    }, [sourceDataFeReceive]);


    const handleSetSearchResultsFeeReceive = (data) => {

        let transactions =
            Array.isArray(data)
                ? data
                : Array.isArray(data?.results)
                    ? data.results
                    : [];


        setFilterFeeReceive(transactions);

        // ⭐ IMPORTANT: clear selection if no data
        if (transactions.length === 0) {
            setselectedFeeReceive([]);
        }
    };

    const lastValidFilterQueryRef = useRef('');

    useEffect(() => {
        let query = "";

        if (typeof filterQueryStringFeeReceive === "string") {
            query = filterQueryStringFeeReceive;
        } else if (
            typeof filterQueryStringFeeReceive === "object" &&
            filterQueryStringFeeReceive !== null
        ) {
            query = new URLSearchParams(filterQueryStringFeeReceive).toString();
        }

        if (query.trim() !== "") {
            lastValidFilterQueryRef.current = query;
        }
    }, [filterQueryStringFeeReceive]);



    const handlePageChangeFeeReceive = ({ selected }) => {
        setCurrentPageFeeReceive(selected);
        triggerTableLoading();
    };

    return (
        <>
            {isLoading ? (
                <SpinnerLoader />
            ) : (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                    overflow: "hidden",
                    position: "relative",
                }}>

                    {/* ── FIXED: Title + Receive Button ── */}
                    <div style={{ flexShrink: 0, padding: "0 12px" }}>
                        <div className="row">
                            <div className="col-md-6">
                                <h2 className="main-heading">Transactions</h2>
                            </div>
                            <div className="col-md-6 d-flex justify-content-end" style={{ gap: "15px" }}>
                                {hasPermission("can-receive-payment") && (
                                    <button className="add-btn ms-2" onClick={() => openModal()}>
                                        <span className="me-2">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                                                <text x="7" y="17" fontSize="14" fontFamily="Arial" fill="currentColor">₹</text>
                                            </svg>
                                        </span>
                                        Receive
                                    </button>
                                )}
                                {hasPermission("can-refund-payment") && (
                                    <button className="add-btn ms-2" onClick={() => openRefundModal()}>
                                        <span className="me-2">
                                            {/* Same rupee coin as Receive, with the arrow reversed — money going out. */}
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                                                <text x="7" y="17" fontSize="14" fontFamily="Arial" fill="currentColor">₹</text>
                                            </svg>
                                        </span>
                                        Refund
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* ── FIXED: Stats Cards ── */}
                    <div style={{ flexShrink: 0, padding: "8px 12px" }}>
                        <div className="dashboard-cards row" style={{ justifyContent: "space-around" }}>
                            <TransactionsStats
                                label="Cash In Hands" icon={profileicon}
                                iconColor="#39886F" bgColor="#39886F0D" circleColor="#39886F"
                                numbers={txnstats?.payment_method_summary?.find(m => m.payment_method === "Cash")?.total_amount}
                                widths="380px" showCircle={false}
                                onNumberClick={handleTransfer}
                                lastReconcileDate={txnstats?.detailed_breakdown?.last_cash_collection}
                                onReconcileClick={handleCashInHandsReconcile}
                            />
                            <TransactionsStats
                                label="No of demand draft" icon={profileicon2}
                                iconColor="#0E9DED" bgColor="#0E9DED0D"
                                numbers={txnstats?.payment_method_summary?.find(m => m.payment_method === "Demand Draft")?.transaction_count}
                                transactios={txnstats?.payment_method_summary?.find(m => m.payment_method === "Demand Draft")?.total_amount}
                                widths="350px" showCircle={false} onNumberClick={handleTransfer}
                            />
                            <TransactionsStats
                                label="No of cheque" icon={profileicon3}
                                iconColor="#FF9B04" bgColor="#FF9B040D" circleColor="#FF9B04"
                                numbers={txnstats?.payment_method_summary?.find(m => m.payment_method === "Cheque")?.transaction_count}
                                transactios={txnstats?.payment_method_summary?.find(m => m.payment_method === "Cheque")?.total_amount}
                                widths="350px" showCircle={false} onNumberClick={handleTransfer}
                            />
                        </div>
                    </div>

                    {/* ── FIXED: Tabs + Search + Filter ── */}
                    <div style={{ flexShrink: 0, padding: "8px 12px" }}>
                        <div className="row" style={{ alignItems: "center" }}>
                            <div className="col-md-6">
                                <div className="tabs-container">
                                    <div
                                        className={`tab-item ${activeTab === "remittance" ? "active" : ""}`}
                                        onClick={() => navigate("/finance/remittances")}
                                    >
                                        Remittances ({totalCount})
                                    </div>
                                    <div
                                        className={`tab-item ${activeTab === "receiving" ? "active" : ""}`}
                                        onClick={() => navigate("/finance/transactions")}
                                    >
                                        Receivings ({totalCountFeeReceive})
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex justify-content-center align-items-center gap-2">
                                <SearchingBar
                                    placeholder={isRemittance ? "Search by remitter name, instrument type…" : "Search by name, reg. no…"}
                                    url={isRemittance ? "finance/remittances" : "finance/transactions"}
                                    filterQueryString={isRemittance ? filterQueryString : filterQueryStringFeeReceive}
                                    setResults={isRemittance ? handleSetSearchResults : handleSetSearchResultsFeeReceive}
                                    setIsSearchMode={isRemittance ? setIsSearchModeFeeRemitance : setIsSearchModeFeeReceive}
                                    setTotalCount={isRemittance ? setTotalCount : setTotalCountFeeReceive}
                                    setFilterQueryString={isRemittance ? setFilterQueryString : setFilterQueryStringFeeReceive}
                                    setSearchLoading={isRemittance ? setSearchLoading : setSearchLoadingFeeReceive}
                                    setCurrentPage={isRemittance ? setCurrentPage : setCurrentPageFeeReceive}
                                    ref={searchInputRef}
                                    onTransitionChange={isRemittance ? setIsSearchPending : setIsSearchPendingFeeReceive}
                                />
                                <div className="d-flex align-items-center gap-2">
                                    <button className="filter-btn" onClick={() => setOpenFilterModal(true)} style={{ height: "43px" }}>
                                        <img src={filtericon} alt="Filter icon" />
                                    </button>
                                    <button
                                        className="filter-btn"
                                        style={{ background: "white", border: "1px solid black", height: "43px" }}
                                        onClick={isRemittance ? handleExportExcelRemittance : handleExportExcel}
                                    >
                                        <img src={exporticon} alt="Export icon" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── SCROLLABLE BOTTOM: Table (left) + Details (right) ── */}
                    <div style={{
                        display: "flex",
                        flex: 1,
                        minHeight: 0,
                        overflow: "hidden",
                        padding: "0 12px",
                        alignItems: "stretch",
                    }}>

                        {/* LEFT: Table */}
                        <div style={{
                            flex: "0 0 75%",
                            maxWidth: "75%",
                            display: "flex",
                            flexDirection: "column",
                            minHeight: 0,
                            overflow: "hidden",
                            paddingRight: "12px",
                        }}>
                            {isRemittance ? (
                                <RemittanceTransactions
                                    formattedData={formattedData}
                                    handleRowClick={handleRowClick}
                                    isLoading={isLoading}
                                    selectedTxnDetails={selectedTxnDetails}
                                    handlePageChange={handlePageChange}
                                    currentPage={currentPage}
                                    isSearchLoading={isSearchLoading}
                                    filterQueryString={filterQueryString}
                                    pageCounts={pageCounts}
                                    filterLoading={filterLoading}
                                    getTransactions={getTransactions}
                                    setselectedTxnForReconcile={setselectedTxnForReconcile}
                                    setShowTransferReconcileModals={setShowTransferReconcileModals}
                                    handleResendOtp={handleResendOtp}
                                    pageLoading={pageLoading}
                                    tableLoading={tableLoading}
                                    showSpinner={showSpinner}
                                />
                            ) : (
                                <ReceiveTransactions
                                    formattedData={formattedDataFeeReceived}
                                    handleRowClick={handleRowClickReceiveFee}
                                    isLoading={isLoadingFeeReceive}
                                    selectedTxnDetails={selectedFeeReceive}
                                    handlePageChange={handlePageChangeFeeReceive}
                                    currentPage={currentPageFeeReceive}
                                    isSearchLoading={isSearchLoadingFeeReceive}
                                    pageCounts={pageCountsFeeReceive}
                                    filterLoading={filterLoadingFeeReceive}
                                    filterQueryStringFeeReceive={filterQueryStringFeeReceive}
                                    tableLoading={tableLoading}
                                    showSpinner={showSpinnerFeeReceive}
                                />
                            )}
                        </div>

                        {/* RIGHT: Short Details Panel */}
                        <div style={{
                            flex: "0 0 25%",
                            maxWidth: "25%",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                        }}>
                            {isRemittance ? (
                                !showSpinner && selectedTxnDetails && Object.keys(selectedTxnDetails).length > 0 && (
                                    <RemittanceShortDetails selectedFeeDetails={selectedTxnDetails} />
                                )
                            ) : (
                                !showSpinnerFeeReceive && selectedFeeReceive && Object.keys(selectedFeeReceive).length > 0 && (
                                    <TransactionsShortDetails selectedFeeDetails={selectedFeeReceive} />
                                )
                            )}
                        </div>
                    </div>

                    <TableLoaderOverlay isLoading={tableLoading} />
                </div>
            )}

            <ReceivePayment isReceivedPaymentModalOpen={isReceivedPaymentModalOpen} onClose={closeModal} modeOfPayment={modeOfPayment} setModeOfPayment={setModeOfPayment} currentPage={currentPage} getTransactions={getTransactions}
                getTransactionStats={getTransactionStats} getFeeReceivedData={getFeeReceivedData} currentPageFeeReceive={currentPageFeeReceive}
            />

            <RefundPayment isRefundModalOpen={isRefundModalOpen} onClose={closeRefundModal} modeOfPayment={modeOfPayment} />

            <IndividualReceivePayment individualReceivePaymentModal={individualReceivePaymentModal} onClose={closeIndividualReceivePaymentModal} setIndividualReceivePaymentModal={setIndividualReceivePaymentModal} selectedFeeDetails={selectedFeeDetails} modeOfPayment={modeOfPayment} setModeOfPayment={setModeOfPayment} />



            <FilterTransactionModal fromDate={isRemittance ? fromDate : fromDateFeeReceive} setFromDate={isRemittance ? setFromDate : setFromDateFeeReceive} toDate={isRemittance ? toDate : toDateFeeReceive} setToDate={isRemittance ? setToDate : setToDateFeeReceive}
                handleSearch={isRemittance ? handleRemittancesSearch : handleFeeReceiveSearch} isOpen={openFilterModal} onCancel={() => setOpenFilterModal(false)}
                transactionType={isRemittance ? "Remitance" : "Receive"} activeTab={isRemittance ? activeTabFilterModal : activeTabFilterModalFeeReceive} setActiveTab={isRemittance ? setActiveTabFiltermodal : setActiveTabFiltermodalFeeReceive}
                statusFilter={isRemittance ? statusFilter : statusFilterFeeReceive} setStatusFilter={isRemittance ? setStatusFilter : setStatusFilterFeeReceive} remitterName={remitterName}
                setRemitterName={setRemitterName} setInstrumentType={setInstrumentType} instrumentType={instrumentType} getTransactions={getTransactions}
                getFeeReceivedData={getFeeReceivedData} instrumentTypeFeeReceive={instrumentTypeFeeReceive} setInstrumentTypeFeeReceive={setInstrumentTypeFeeReceive} setFilterQueryStringFeeReceive={setFilterQueryStringFeeReceive} setFilterQueryString={setFilterQueryString}
                fromDateFeeReceive={fromDateFeeReceive} setFromDateFeeReceive={setFromDateFeeReceive} toDateFeeReceive={toDateFeeReceive} setToDateFeeReceive={setToDateFeeReceive} getToday={getToday}
                setIsInitialLoad={setIsInitialLoad} setIsInitialLoadFeeReceive={setIsInitialLoadFeeReceive}
                transactionsReceivedBy={receivingEmployeeData?.transactions_received_by}
                transactionsReceivedFrom={receivingEmployeeData?.transactions_received_from}
                receiveFilters={receiveFilters}
                setReceiveFilters={setReceiveFilters}
                remittancesDepositedBy={receivingEmployeeData.remittances_deposited_by}
                remittancesDepositedIn={receivingEmployeeData.remittances_deposited_in}
                isLoading={isRemittance ? isSearchLoading : isSearchLoadingFeeReceive}
                filterQueryString={isRemittance ? filterQueryString : filterQueryStringFeeReceive}
            />


            <TransferTransactions onClose={closeTransferTransactionsModal} isOpen={showTransferTransactionsModal}
                selectedTxnStats={selectedTxnStats} getTransactionStats={getTransactionStats} getFeeReceivedData={getFeeReceivedData} getTransactions={getTransactions} />

            <TransferReconcile onClose={closeTransferReconcileModal} isOpen={showTransferReconcileModal}
                selectedTxnStats={selectedTxnForReconcile} getTransactions={getTransactions} currentPage={currentPage}

                currentFilters={filterQueryString} setFilterQueryString={setFilterQueryString} setCurrentPage={setCurrentPage} />

            <CashReconcile
                isOpen={openCashInHandsReconcile}
                onClose={closeCashInHandsReconcileModal}
                getTransactionStats={getTransactionStats}
                cashInHand={txnstats?.payment_method_summary?.find(m => m.payment_method === "Cash")?.total_amount} // pass from  
            />

            <OtpModal
                // key={otpModalKey}
                title='Verify Remitance'
                heading={`Please select the employee to transfer. `}
                isOpen={otpModalOpen}
                onConfirm={handleConfirmOtp}
                onCancel={handleCancelOtp}
                onResend={handlesResendOtpToAssignedPerson}
                studentResponse={studentResponse}
                remittancemployees={helpdeskperson}
                // fromDiscountDashboard={"No need to resend otp"}
                remittances={selectedTxnDetails}
            />

        </>
    );
};


export default TransactionsLayouts